<template>
    <add-edit-mitigatingbarrier></add-edit-mitigatingbarrier>
</template>

<script>
import AddEditMitigatingbarrier from "@/layouts/components/risk-management/mitigating-barriers/addedit-mitigatingbarrier.vue";

export default {
 components : {
   AddEditMitigatingbarrier
 },
};
</script>